export type EventType =
  | 'oficina'
  | 'implantacao'
  | 'visita_semanal'
  | 'coleta_final'
  | 'outro';

export interface ResearchEvent {
  id: string;
  title: string;
  photoUrl: string;
  school: string;
  type: EventType;
  customTypeLabel?: string;
  /** Quando true, ignora o período abaixo e usa todos os dados do Firebase, sincronizados automaticamente. */
  noPeriod?: boolean;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  createdBy: string;
  collaboratorEmails: string[];
  participantCount: number;
  recordCount: number;
  createdAt: string;
  lastSyncAt: string;
}

export interface CreateEventInput {
  title: string;
  photoUrl: string;
  school: string;
  type: EventType;
  customTypeLabel?: string;
  noPeriod?: boolean;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  collaboratorEmails: string[];
}

export interface CrossEventInsight {
  id: string;
  title: string;
  description: string;
  metric?: string;
}

export const EVENT_TYPE_LABELS: Record<EventType, string> = {
  oficina: 'Oficina',
  implantacao: 'Implantação',
  visita_semanal: 'Visita semanal',
  coleta_final: 'Coleta final',
  outro: 'Outro',
};

export function eventTypeLabel(event: ResearchEvent): string {
  if (event.type === 'outro' && event.customTypeLabel) {
    return event.customTypeLabel;
  }
  return EVENT_TYPE_LABELS[event.type];
}
